interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1).filter(
    (item) => item === 1 || item === totalPages || Math.abs(item - page) <= 1,
  );

  return (
    <nav className="mt-8 flex items-center justify-center gap-1.5" aria-label="分页">
      <button
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-sm" />
        上一页
      </button>
      {pages.map((item, index) => {
        const prev = pages[index - 1];
        const gap = prev && item - prev > 1;
        return (
          <span key={item} className="flex items-center gap-1.5">
            {gap ? <span className="px-1 text-xs text-foreground-400">…</span> : null}
            <button
              onClick={() => onChange(item)}
              aria-current={page === item ? "page" : undefined}
              className={`flex h-9 w-9 items-center justify-center rounded-md text-xs transition-colors ${
                page === item
                  ? "bg-primary-600 text-background-50"
                  : "border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {item}
            </button>
          </span>
        );
      })}
      <button
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line text-sm" />
      </button>
    </nav>
  );
}